// Require pointer events polyfill
require('pepjs');

var Cortona3DSolo = require('solo');
var util = require('lib/util');

var options = {
    mouseClickThreshold: 3,
    skipContextGeometry: false,
    disableObjectEvents: false
};

Object.defineProperty(options, 'FEATURE_PICK_TOPMOST', {
    get: function () { return !Cortona3DSolo.app.recursiveObjectLookup },
    enumerable: true
});

var DOUBLE_TAP_TIME = 250;
var PRESS_TIME = 750;

var debounceTimeout = {};

var whichToButtons = [0, 1, 4, 2];
var buttonToButtons = [1, 4, 2, 8, 16];

var now = function () {
    return new Date().valueOf();
};

var getMouseEventArguments = function (event, isMove) {
    var keys = +(event.shiftKey && 1) | +(event.ctrlKey && 2) | +(event.altKey && 4);
    //var buttons = (event.which !== undefined) ? whichToButton[event.which] : event.button;
    var buttons;
    if (isMove) {
        buttons = (event.buttons !== undefined) ? event.buttons : ((event.which !== undefined) ? whichToButtons[event.which] : buttonToButtons[event.button]);
    } else {
        buttons = (event.which !== undefined) ? whichToButtons[event.which] : buttonToButtons[event.button];
    }

    var target = event.target || event.srcElement,
        rect = target.getBoundingClientRect(),
        offsetX = event.clientX - rect.left,
        offsetY = event.clientY - rect.top;

    return [offsetX, offsetY, buttons, keys, event];
};

var distance = function (aVec1, aVec2) {
    var dx = aVec1[0] - aVec2[0],
        dy = aVec1[1] - aVec2[1];
    return Math.sqrt(dx * dx + dy * dy);
};

var args;

var isMouseMoved = function (mouseArgs1, mouseArgs2) {
    if (!mouseArgs1 || !mouseArgs2) return false;
    return distance(mouseArgs1, mouseArgs2) > options.mouseClickThreshold;
};

var isPress = function (timestamp) {
    return (now() - timestamp) > PRESS_TIME;
}

var overObject = null;
var lastMouseArguments = null;
var lastMouseMove = null;
var pointerdownTime = 0;

/* Firefox title changes issue */
var stealthyLayer = null;
var isFF = navigator.userAgent.lastIndexOf("Firefox") > 0;
var createStealthyLayer = function () {
    if (isFF) {
        stealthyLayer = document.createElement('div');
        stealthyLayer.style.position = 'absolute';
        stealthyLayer.style.top = '0';
        stealthyLayer.style.bottom = '0';
        stealthyLayer.style.left = '0';
        stealthyLayer.style.right = '0';
        stealthyLayer.style.zIndex = 10000;
        stealthyLayer.onmousemove = function (e) {
            e = e || window.event;
            document.body.removeChild(e.target);
            stealthyLayer = null;
            e.preventDefault();
            e.stopPropagation();
            return false;
        };
        setTimeout(function () {
            if (stealthyLayer) {
                document.body.removeChild(stealthyLayer);
                stealthyLayer = null;
            }
        }, 100);
        document.body.appendChild(stealthyLayer);
    }
};

var m_lastPickInfo;

var eventHandlers = {
    pointermove: function (event) {
        var target = event.target || event.srcElement,
            rect = target.getBoundingClientRect(),
            offsetX = event.clientX - rect.left,
            offsetY = event.clientY - rect.top,
            mouseArguments = getMouseEventArguments(event, true);

        var handleOld = overObject ? overObject.handle : null;

        if (lastMouseMove && !isMouseMoved(lastMouseMove, mouseArguments)) return;

        lastMouseMove = mouseArguments;

        if (!mouseArguments[2]) { // buttons === 0

            m_lastPickInfo = pickObjectChain(offsetX, offsetY);

            var obj = m_lastPickInfo.picked;

            if (obj) {
                Cortona3DSolo.dispatch('touch.didObjectMove', obj.handle, obj.name);
            }

            var handleNew = obj ? obj.handle : null;

            if (handleOld !== handleNew) {
                if (overObject) {
                    createStealthyLayer();
                    Cortona3DSolo.dispatch('touch.didObjectOut', handleOld, overObject.name);
                }
                if (obj) {
                    Cortona3DSolo.dispatch('touch.didObjectEnter', handleNew, obj.name);
                }
            }

            overObject = obj;
        } else {
            if (overObject) {
                createStealthyLayer();
                Cortona3DSolo.dispatch('touch.didObjectOut', handleOld, overObject.name);
                overObject = null;
            }
        }
        args = ['touch.didPointerMove'].concat(mouseArguments);
        Cortona3DSolo.dispatch.apply(Cortona3DSolo, args);
    },
    pointerenter: function (event) {
        if (stealthyLayer) return;
        Cortona3DSolo.dispatch('touch.didPointerEnter');
        lastMouseMove = null;
    },
    pointerout: function (event) {
        if (stealthyLayer) return;
        if (overObject) {
            Cortona3DSolo.dispatch('touch.didObjectOut', overObject.handle, overObject.name);
            overObject = null;
            createStealthyLayer();
        }
        Cortona3DSolo.dispatch('touch.didPointerOut');
        lastMouseMove = null;
    },
    pointerdown: function (event) {
        pointerdownTime = now();
        lastMouseArguments = getMouseEventArguments(event);
        args = ['touch.didPointerDown'].concat(lastMouseArguments);
        Cortona3DSolo.dispatch.apply(Cortona3DSolo, args);
    },
    pointerup: function (event) {
        var target = event.target || event.srcElement,
            rect = target.getBoundingClientRect(),
            offsetX = event.clientX - rect.left,
            offsetY = event.clientY - rect.top,
            mouseArguments = getMouseEventArguments(event);

        m_lastPickInfo = pickObjectChain(offsetX, offsetY);

        var obj = m_lastPickInfo.picked;

        if (!isMouseMoved(lastMouseArguments, mouseArguments) && !isPress(pointerdownTime)) {
            if (!obj) obj = {
                handle: 0,
                name: ''
            };
            if (!debounceTimeout[obj.name]) {
                debounceTimeout[obj.name] = {
                    lpi: m_lastPickInfo,
                    t: setTimeout(function () {
                        var currentLastPickInfo = m_lastPickInfo;
                        m_lastPickInfo = debounceTimeout[obj.name].lpi;
                        delete debounceTimeout[obj.name];
                        args = ['touch.didObjectClick', obj.handle, obj.name].concat(mouseArguments);
                        Cortona3DSolo.dispatch.apply(Cortona3DSolo, args);
                        m_lastPickInfo = currentLastPickInfo;
                    }, DOUBLE_TAP_TIME)
                };
            } else {
                clearTimeout(debounceTimeout[obj.name].t);
                delete debounceTimeout[obj.name];
            }
        }

        var handleOld = overObject ? overObject.handle : null,
            handleNew = obj ? obj.handle : null;

        if (handleOld !== handleNew) {
            if (overObject) {
                createStealthyLayer();
                Cortona3DSolo.dispatch('touch.didObjectOut', handleOld, overObject.name);
            }
            if (obj) {
                Cortona3DSolo.dispatch('touch.didObjectEnter', handleNew, obj.name);
            }
        }

        overObject = obj;

        args = ['touch.didPointerUp'].concat(mouseArguments);
        Cortona3DSolo.dispatch.apply(Cortona3DSolo, args);

        lastMouseArguments = null;
    }
};

if (navigator.pointerEnabled === false) {
    for (var eventName in eventHandlers) {
        if (eventName.indexOf('pointer') === 0) {
            eventHandlers[eventName.replace(/^pointer/, 'mouse')] = eventHandlers[eventName];
            delete eventHandlers[eventName];
        }
    }
}

function attach() {
    if (Cortona3DSolo.core && Cortona3DSolo.core.runtimeReady && Cortona3DSolo.core.canvas) {
        var canvas = Cortona3DSolo.core.canvas;
        for (eventName in eventHandlers) {
            canvas.addEventListener(eventName, eventHandlers[eventName], false);
        }
    } else {
        Cortona3DSolo.on('app.firstFrameDidArrive', attach);
    }
}

attach();

/**
 * Search for all 3D objects through which the beam passes from a given point on the 3D window in the direction of the camera.
 * 
 * @function pickObjectsRightThrough
 * @memberof module:solo.touch
 * @param {number} x - The X coordinate relative to the element `<canvas>`
 * @param {number} y - The Y coordinate relative to the element `<canvas>`
 * @returns {Handle[]} An array of all found 3D objects
 */
function pickObjectsRightThrough(x, y) {
    var chain = [],
        obj;

    obj = Cortona3DSolo.app.pickObject(x, y, false);

    while (obj) {
        if (!options.skipContextGeometry || !(Cortona3DSolo.app.getObjectFlags(obj.handle) & 1)) chain.push(obj.handle);
        Cortona3DSolo.app.setObjectIgnorableByPicker(obj.handle, true);
        obj = Cortona3DSolo.app.pickObject(x, y, false);
    }

    chain.forEach(function (handle) {
        Cortona3DSolo.app.setObjectIgnorableByPicker(handle, false);
    });

    return chain;
}

function pickObjectChain(x, y, topMost) {
    var chain = [],
        handle,
        topmost = typeof topMost === 'undefined' ? !Cortona3DSolo.app.recursiveObjectLookup : !!topMost,
        obj = options.disableObjectEvents ? null : Cortona3DSolo.app.pickObject(x, y, topmost);

    if (obj) {
        for (handle = obj.handle; handle; handle = Cortona3DSolo.app.getParentObject(handle)) {
            chain.push(handle);
        }
        if (options.skipContextGeometry) {
            if (chain.find(function (h) { return Cortona3DSolo.app.getObjectFlags(h) & 1; })) {
                chain = [];
                obj = null;
            }
        }
    }
    return {
        x: x,
        y: y,
        picked: obj,
        chain: chain
    };
}


var soloExports = {
    /**
     * The namespace to work with pointer-events in the 3D window.
     * 
     * Requires the use of internal modules `"touch"` and `"core"`.
     * 
     * @requires touch
     * @requires core
     * @namespace
     * @memberof module:solo
     * @since 1.5.6
     * @example
Cortona3DSolo.use('core');
Cortona3DSolo.use('touch');
Cortona3DSolo.on('touch.didObjectClick', function () {
    Cortona3DSolo.app.procedure.play();
});
Cortona3DSolo.initialize('procedure.wrl');
     */
    touch: {
        /**
         * @static
         * @member {object} options
         * @property {number} options.mouseClickThreshold=3 
         * @property {boolean} options.skipContextGeometry=false
         * @property {boolean} options.disableObjectEvents=false
         * @memberof module:solo.touch
         */
        options: options,
        pickObjectsRightThrough: pickObjectsRightThrough,
        pickObjectChain: pickObjectChain

        //didObjectEnter
        //didObjectOut
        //didObjectMove
        //didObjectClick

        //didPointerMove
        //didPointerEnter
        //didPointerDown
        //didPointerUp
    }
};

/**
 * Gets the information about the process of the last selection of a 3D object when pointer-events occur.
 * 
 * @static
 * @member {PickInfo} lastPickInfo
 * @readonly
 * @memberof module:solo.touch
 */

Object.defineProperty(soloExports.touch, 'lastPickInfo', {
    get: function () {
        return m_lastPickInfo;
    },
    enumerable: true
});

module.exports = {
    configure: function (options) {
        util.expand(soloExports.touch.options, options);
        return soloExports;
    }
};

/**
 * The hook method is invoked when a pointer is moved over the object in the 3D window.
 * 
 * @function didObjectEnter
 * @abstract 
 * @memberof module:solo.touch
 * @param {Handle} handle - Handle of the object in the 3D window
 * @param {string} name - Name of the object in the 3D window
 * @see The corresponding event {@link event:"touch.didObjectEnter" "touch.didObjectEnter"}
 */
/**
 * @event "touch.didObjectEnter"
 * @see The corresponding hook method {@link module:solo.touch.didObjectEnter touch.didObjectEnter()}
 */

/**
 * The hook method is invoked when a pointer is moved off the object in the 3D window.
 * 
 * @function didObjectOut
 * @abstract 
 * @memberof module:solo.touch
 * @param {Handle} handle - Handle of the object in the 3D window
 * @param {string} name - Name of the object in the 3D window
 * @see The corresponding event {@link event:"touch.didObjectOut" "touch.didObjectOut"}
 */
/**
 * @event "touch.didObjectOut"
 * @see The corresponding hook method {@link module:solo.touch.didObjectOut touch.didObjectOut()}
 */

/**
 * The hook method is invoked when a pointer is moved while over an object in the 3D window.
 * 
 * @function didObjectMove
 * @abstract 
 * @memberof module:solo.touch
 * @param {Handle} handle - Handle of the object in the 3D window
 * @param {string} name - Name of the object in the 3D window
 * @see The corresponding event {@link event:"touch.didObjectMove" "touch.didObjectMove"}
 */
/**
 * @event "touch.didObjectMove"
 * @see The corresponding hook method {@link module:solo.touch.didObjectMove touch.didObjectMove()}
 */

/**
 * The hook method is invoked when the pointer was in a “pressed” and then “released” state on an object in the 3D window.
 * 
 * @function didObjectClick
 * @abstract 
 * @memberof module:solo.touch
 * @param {Handle} handle - Handle of the object in the 3D window
 * @param {string} name - Name of the object in the 3D window
 * @param {number} x - The X coordinate of the pointer in local (canvas) coordinates
 * @param {number} y - The Y coordinate of the pointer in local (canvas) coordinates
 * @param {number} buttons - Bitwise flags of the buttons depressed when the event was fired: 
 * - Left=1 
 * - Right=2 
 * - Middle (wheel)=4 
 * @param {number} keys - Bitwise control key flags that were pressed when the event was fired: 
 * - Shift=1
 * - Ctrl=2
 * - Alt=4
 * @param {object} event - Source PointerEvent or MouseEvent object
 * @see The corresponding event {@link event:"touch.didObjectClick" "touch.didObjectClick"}
 */
/**
 * @event "touch.didObjectClick"
 * @see The corresponding hook method {@link module:solo.touch.didObjectClick touch.didObjectClick()}
 */

/**
 * The hook method is invoked when a pointer is moved in the 3D window.
 * 
 * @function didPointerMove
 * @abstract 
 * @memberof module:solo.touch
 * @param {number} x - The X coordinate of the pointer in local (canvas) coordinates
 * @param {number} y - The Y coordinate of the pointer in local (canvas) coordinates
 * @param {number} buttons - Bitwise flags of the buttons depressed when the event was fired:
 * - Left=1
 * - Right=2
 * - Middle (wheel)=4 
 * @param {number} keys - Bitwise control key flags that were pressed when the event was fired: 
 * - Shift=1
 * - Ctrl=2
 * - Alt=4
 * @param {object} event - Source PointerEvent or MouseEvent object
 * @see The corresponding event {@link event:"touch.didPointerMove" "touch.didPointerMove"}
 */
/**
 * @event "touch.didPointerMove"
 * @see The corresponding hook method {@link module:solo.touch.didPointerMove touch.didPointerMove()}
 */

/**
 * The hook method is invoked when a pointer is moved over the 3D window.
 * 
 * @function didPointerEnter
 * @abstract 
 * @memberof module:solo.touch
 * @see The corresponding event {@link event:"touch.didPointerEnter" "touch.didPointerEnter"}
 */
/**
 * @event "touch.didPointerEnter"
 * @see The corresponding hook method {@link module:solo.touch.didPointerEnter touch.didPointerEnter()}
 */

/**
 * The hook method is invoked when a pointer is moved off the 3D window.
 * 
 * @function didPointerOut
 * @abstract 
 * @memberof module:solo.touch
 * @see The corresponding event {@link event:"touch.didPointerOut" "touch.didPointerOut"}
 */
/**
 * @event "touch.didPointerOut"
 * @see The corresponding hook method {@link module:solo.touch.didPointerOut touch.didPointerOut()}
 */

/**
 * The hook method is invoked when a pointing device button is pressed on the 3D window.
 * 
 * @function didPointerDown
 * @abstract 
 * @memberof module:solo.touch
 * @param {number} x - The X coordinate of the pointer in local (canvas) coordinates
 * @param {number} y - The Y coordinate of the pointer in local (canvas) coordinates
 * @param {number} buttons - The button number that was pressed when the event was fired: 
 * - Left=1
 * - Right=2
 * - Middle (wheel)=4
 * @param {number} keys - Bitwise control key flags that were pressed when the event was fired:
 * - Shift=1
 * - Ctrl=2
 * - Alt=4
 * @param {object} event - Source PointerEvent or MouseEvent object
 * @see The corresponding event {@link event:"touch.didPointerDown" "touch.didPointerDown"}
 */
/**
 * @event "touch.didPointerDown"
 * @see The corresponding hook method {@link module:solo.touch.didPointerDown touch.didPointerDown()}
 */

/**
 * The hook method is invoked when a pointing device button is released over the 3D window.
 * 
 * @function didPointerUp
 * @abstract 
 * @memberof module:solo.touch
 * @param {number} x - The X coordinate of the pointer in local (canvas) coordinates
 * @param {number} y - The Y coordinate of the pointer in local (canvas) coordinates
 * @param {number} buttons - Bitwise flags of the buttons depressed when the event was fired:
 * - Left=1
 * - Right=2
 * - Middle (wheel)=4 
 * @param {number} keys - Bitwise control key flags that were pressed when the event was fired:
 * - Shift=1
 * - Ctrl=2
 * - Alt=4
 * @param {object} event - Source PointerEvent or MouseEvent object
 * @see The corresponding event {@link event:"touch.didPointerUp" "touch.didPointerUp"}
 */
/**
 * @event "touch.didPointerUp"
 * @see The corresponding hook method {@link module:solo.touch.didPointerUp touch.didPointerUp()}
 */

/**
 * Information about the pick process of a 3D object, for example:
 * ```
 * { 
 *     x: 153,
 *     y: 27,
 *     picked: 5698800,
 *     chain: [5698800,6100248,6100664,6101200,6101848]
 * }
 * ```
 * @typedef {object} PickInfo
 * @param {number} x - The X coordinate of 3D window
 * @param {number} y - The Y coordinate of 3D window
 * @prop {Handle} picked A handle of the picked 3D object
 * @prop {Handle[]} chain The picked 3D object and its ancestors. The ancestors of the picked 3D object consist of the parent of the picked 3D object and the parent's parent and so on. The root element is last.
 * @see {@link module:solo.touch.lastPickInfo touch.lastPickInfo}
 */